// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3I0eo","content":"GlobalSearch_content__1J5jz"};